<template>
  <div
    class="main_wrap alvexo_plus_wrapper"
    id="app"
    :class="[lang, { activeScroll: viewPortNotAtTop, active: loggedAndActive }]"
  >
    <HeaderBackground />
    <router-view></router-view>
    <Loader />

    <transition name="modal"> </transition>
    <AlvexoBanner v-if="shouldBannerAppear" :isLoggedIn="isLoggedIn" />
  </div>
</template>

<script>
import { importMomentLang } from "@/utils/general";
import "isomorphic-fetch"; /*i.e loading problem fix*/
import Vue from "vue";

import Loader from "./components/Loader";
import HeaderBackground from "@/components/HeaderBackground";
import AlvexoBanner from "@/components/AlvexoBanner";
import { mapGetters, mapMutations, mapActions, mapState } from "vuex";

export default {
  components: { Loader, HeaderBackground, AlvexoBanner },
  data() {
    return {
      viewPortNotAtTop: false
    };
  },
  computed: {
    ...mapState(["isLoggedIn", "lang", "webInfo"]),
    ...mapGetters(["loggedAndActive","alvexoWebsite"]),
    shouldBannerAppear: function() {
      //optional TODO, hold the relevant pages on state\var and automatically build the regex out of them
      let isPageWithBanner = new RegExp(
        "financial-tv/?$|news/?$|ebooks/?$|webinars/?$|/instruments/"
      ).test(this.$route.fullPath);
      return isPageWithBanner || (!isPageWithBanner && this.loggedAndActive);
      // return isPageWithBanner;
    }
  },
  methods: {
    ...mapMutations(["updateWebsiteInfo","getRegulationFromBackend"]),
    ...mapActions(["updateAppLang"]),
    defineGlobalFunForUserStatusCallback: function() {
      window["updateAlvexoPlusLoginStatus"] = loginData => {
        this.$store.dispatch("updateUserStatus", loginData);
      };
    },

    updateViewPortDistanceFromTop() {
      /* console.log("scrolling")*/
      if (window.scrollY != 0) {
        this.viewPortNotAtTop = true;
      } else {
        this.viewPortNotAtTop = false;
      }
    },
    loadResourcesFromWebsite(){
      if (process.env.NODE_ENV === "development"){
        this.loadWebsiteAuthenticationScripts();
        this.loadBootstrapScripts();
      }
    },
    loadWebsiteAuthenticationScripts: function() {
        const baseScriptUrl = `${this.alvexoWebsite}assets/js/`;
        Vue.loadScript(baseScriptUrl + "lib/jquery/jquery.min.js").then(() => {
          Vue.loadScript(baseScriptUrl + "website.js").then(() => {
            Vue.loadScript(baseScriptUrl + "components.js");
          });
        });
    },
    loadBootstrapScripts: function(){
      const baseUrl = `${this.alvexoWebsite}assets/lib/bootstrap-4.3.1/`;
      const head = document.getElementsByTagName("head")[0];
      let link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = baseUrl + "css/bootstrap.min.css";
      head.appendChild(link);
    }
  },
  watch: {
    '$route.params.lang': function() {
      importMomentLang();
    }
  },
  created() {
    this.defineGlobalFunForUserStatusCallback();
    this.getRegulationFromBackend();
    this.updateWebsiteInfo(); //must be called outside\before updateAppLang function in order to send it lang param
    this.updateAppLang(this.webInfo.getLang());
    this.loadResourcesFromWebsite();

    window.addEventListener("scroll", this.updateViewPortDistanceFromTop);
  },
  destroyed() {
    window.removeEventListener("scroll", this.updateViewPortDistanceFromTop);
  }
};
</script>

<style lang="scss">
body {
  margin: 0;
}
.alvexo_plus_wrapper {
  font-family: Lato;
  color: #424242;
  &.ar {
    font-family: "Tajawal";
    direction: rtl;
    text-align: right;
  }
  /*bootstrap code which dosen't applays because its uses the body selector*/
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: left;
  background-color: #fff;
  /*end of bootstrap code*/
  @import "assets/styles/differentBootstrapVersionStyles";
  @import "assets/styles/app";
}
@import "assets/styles/fonts";
@import "assets/styles/outOfScopeCss";
//website general fetures modification (as accepted by Ron)
#websiteApp.smartbanner-exist {
  margin-top: 0;
}
.smartbanner {
  display: none;
}
.liveChat {
  display: none;
}
//end of website general fetures modification
//html{scroll-behavior: smooth;}
</style>
<style lang="scss" scoped>
@import "assets/styles/generalScopedCss";
</style>
